import { Component, EventEmitter, Input, Output } from "@angular/core";

/**
 * Cabecera reutilizable con botón de retroceso, un rótulo contextual pequeño
 * (en cursiva) y un título destacado. Pensada para reutilizarse en cualquier
 * módulo (desempeño, inducción, cursos, etc.).
 *
 * Acepta una **acción opcional a la altura del título** por contenido
 * proyectado, con el atributo `sectionHeaderExtra` (el equivalente del
 * `titleExtraComponent` de `app-page-title`):
 *
 * ```html
 * <app-section-header title="Feedback" (back)="back()">
 *   <button sectionHeaderExtra (click)="startMeeting()">Iniciar reunión</button>
 * </app-section-header>
 * ```
 */
@Component({
	selector: "app-section-header",
	templateUrl: "./section-header.component.html",
	styleUrls: ["./section-header.component.scss"],
})
export class SectionHeaderComponent {
	/** Título principal (texto en negrita). */
	@Input() title = "";
	/** Rótulo contextual pequeño que se muestra encima del título. */
	@Input() subtitle = "";
	/** Muestra u oculta el botón de retroceso. */
	@Input() showBack = true;

	/** Se emite al hacer click en la flecha de retroceso. */
	@Output() back = new EventEmitter<void>();

	onBack() {
		this.back.emit();
	}
}
